import { tva } from '@gluestack-ui/utils/nativewind-utils';
import { isWeb } from '@gluestack-ui/utils/nativewind-utils';

const captionTableStyle = isWeb ? 'caption-bottom' : '';

export const tableStyle = tva({
  base: `table border-collapse border-collapse w-[800px]`,
});

export const tableHeaderStyle = tva({
  base: '',
});

export const tableBodyStyle = tva({
  base: '',
});

export const tableFooterStyle = tva({
  base: '',
});

// SE-5780: these bases named a font family that no theme entry ever defined,
// so the class compiled to nothing and the family came from the inherited
// text base regardless. Dropped — table text inherits the DPL body family.
export const tableHeadStyle = tva({
  base: 'flex-1 px-6 py-3 text-left font-bold text-title-sm leading-[22px] text-content-primary',
});

export const tableRowStyleStyle = tva({
  base: 'border-0 border-b border-solid border-outline-default bg-surface-base',
  variants: {
    isHeaderRow: {
      true: '',
    },
    isFooterRow: {
      true: 'border-b-0 ',
    },
  },
});

export const tableDataStyle = tva({
  // Web data cells inherit the regular body face from the design library.
  // A font-weight on the td synthesizes medium weight even inside font-body Text.
  base: `flex-1 px-6 py-3 text-left text-title-sm ${isWeb ? 'font-body' : 'font-medium'} leading-[22px] text-content-primary`,
});

export const tableCaptionStyle = tva({
  base: `${captionTableStyle} px-6 py-[14px] text-[16px] font-normal leading-[22px] text-typography-800 bg-background-50`,
});
